"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: contacts/contacts.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcontacts%2Fcontacts.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientDataVersionToJSON = exports.clientDataVersionFromJSON = exports.AddressBookInfo = exports.AddressBook = exports.Contact = exports.ClientDataVersion = void 0;
const referral_invite_status_1 = require("../common/referral-invite-status");
const protobufPackage = 'com.step.contacts.proto';
/**
 * Used to decide which fields get hashed, will start at VERSION_2
 * Versions 0 and 1 used the SDK lib version to determine what to hash
 */
var ClientDataVersion;
(function (ClientDataVersion) {
    ClientDataVersion["INVALID_DATA_VERSION"] = "INVALID_DATA_VERSION";
    ClientDataVersion["VERSION_2"] = "VERSION_2";
    ClientDataVersion["VERSION_3"] = "VERSION_3";
    ClientDataVersion["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ClientDataVersion || (exports.ClientDataVersion = ClientDataVersion = {}));
function createBaseContact() {
    return {
        id: '',
        emails: [],
        phoneNumbers: [],
        onStep: false,
        friendsCount: 0,
        inviteStatus: referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS,
        inviteIneligible: false,
        referralRank: 0,
        contactName: '',
        hasPicture: false,
        dismissed: false,
    };
}
exports.Contact = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            friendsCount: isSet(object.friendsCount) ? globalThis.Number(object.friendsCount) : 0,
            dismissed: isSet(object.dismissed) ? globalThis.Boolean(object.dismissed) : false,
        };
        if (globalThis.Array.isArray(object?.emails)) {
            message.emails = object.emails.map((e) => globalThis.String(e));
        }
        if (globalThis.Array.isArray(object?.phoneNumbers)) {
            message.phoneNumbers = object.phoneNumbers.map((e) => globalThis.String(e));
        }
        if (isSet(object.onStep)) {
            message.onStep = globalThis.Boolean(object.onStep);
        }
        if (isSet(object.inviteStatus)) {
            message.inviteStatus = (0, referral_invite_status_1.referralInviteStatusFromJSON)(object.inviteStatus);
        }
        if (isSet(object.inviteIneligible)) {
            message.inviteIneligible = globalThis.Boolean(object.inviteIneligible);
        }
        if (isSet(object.referralRank)) {
            message.referralRank = globalThis.Number(object.referralRank);
        }
        if (isSet(object.contactName)) {
            message.contactName = globalThis.String(object.contactName);
        }
        if (isSet(object.hasPicture)) {
            message.hasPicture = globalThis.Boolean(object.hasPicture);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.emails?.length) {
            obj.emails = message.emails;
        }
        if (message.phoneNumbers?.length) {
            obj.phoneNumbers = message.phoneNumbers;
        }
        if (message.onStep !== undefined && message.onStep !== false) {
            obj.onStep = message.onStep;
        }
        if (message.friendsCount !== 0) {
            obj.friendsCount = Math.round(message.friendsCount);
        }
        if (message.inviteStatus !== undefined &&
            message.inviteStatus !== referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS) {
            obj.inviteStatus = (0, referral_invite_status_1.referralInviteStatusToJSON)(message.inviteStatus);
        }
        if (message.inviteIneligible !== undefined && message.inviteIneligible !== false) {
            obj.inviteIneligible = message.inviteIneligible;
        }
        if (message.referralRank !== undefined && message.referralRank !== 0) {
            obj.referralRank = Math.round(message.referralRank);
        }
        if (message.contactName !== undefined && message.contactName !== '') {
            obj.contactName = message.contactName;
        }
        if (message.hasPicture !== undefined && message.hasPicture !== false) {
            obj.hasPicture = message.hasPicture;
        }
        if (message.dismissed !== false) {
            obj.dismissed = message.dismissed;
        }
        return obj;
    },
    create(base) {
        return exports.Contact.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseContact();
        message.id = object.id ?? '';
        message.emails = object.emails?.map((e) => e) || [];
        message.phoneNumbers = object.phoneNumbers?.map((e) => e) || [];
        message.onStep = object.onStep ?? false;
        message.friendsCount = object.friendsCount ?? 0;
        message.inviteStatus = object.inviteStatus ??
            referral_invite_status_1.ReferralInviteStatus.INVALID_REFERRAL_INVITE_STATUS;
        message.inviteIneligible = object.inviteIneligible ?? false;
        message.referralRank = object.referralRank ?? 0;
        message.contactName = object.contactName ?? '';
        message.hasPicture = object.hasPicture ?? false;
        message.dismissed = object.dismissed ?? false;
        return message;
    },
};
function createBaseAddressBook() {
    return { id: '', userId: '', version: 0, createdAtMs: '0', syncedAtMs: '0' };
}
exports.AddressBook = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
            syncedAtMs: isSet(object.syncedAtMs) ? globalThis.String(object.syncedAtMs) : '0',
        };
        if (isSet(object.version)) {
            message.version = globalThis.Number(object.version);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.version !== undefined && message.version !== 0) {
            obj.version = Math.round(message.version);
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.syncedAtMs !== '0') {
            obj.syncedAtMs = message.syncedAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.AddressBook.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddressBook();
        message.id = object.id ?? '';
        message.userId = object.userId ?? '';
        message.version = object.version ?? 0;
        message.createdAtMs = object.createdAtMs ?? '0';
        message.syncedAtMs = object.syncedAtMs ?? '0';
        return message;
    },
};
function createBaseAddressBookInfo() {
    return { addressBook: exports.AddressBook.fromPartial({}) };
}
exports.AddressBookInfo = {
    fromJSON(object) {
        const message = {
            addressBook: isSet(object.addressBook)
                ? exports.AddressBook.fromJSON(object.addressBook)
                : exports.AddressBook.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.addressBook !== undefined) {
            obj.addressBook = exports.AddressBook.toJSON(message.addressBook);
        }
        return obj;
    },
    create(base) {
        return exports.AddressBookInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAddressBookInfo();
        message.addressBook = (object.addressBook !== undefined && object.addressBook !== null)
            ? exports.AddressBook.fromPartial(object.addressBook)
            : exports.AddressBook.fromPartial({});
        return message;
    },
};
function clientDataVersionFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_DATA_VERSION':
            return ClientDataVersion.INVALID_DATA_VERSION;
        case 2:
        case 'VERSION_2':
            return ClientDataVersion.VERSION_2;
        case 3:
        case 'VERSION_3':
            return ClientDataVersion.VERSION_3;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ClientDataVersion.UNRECOGNIZED;
    }
}
exports.clientDataVersionFromJSON = clientDataVersionFromJSON;
function clientDataVersionToJSON(object) {
    switch (object) {
        case ClientDataVersion.INVALID_DATA_VERSION:
            return 'INVALID_DATA_VERSION';
        case ClientDataVersion.VERSION_2:
            return 'VERSION_2';
        case ClientDataVersion.VERSION_3:
            return 'VERSION_3';
        case ClientDataVersion.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.clientDataVersionToJSON = clientDataVersionToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=contacts.js.map